import React from 'react'
import classes from '../styles.module.scss';
import { useKato } from '../../../contexts/kato.context';
import { snpInfoData } from '../../../consts/other.conts';
import { useTranslation } from 'react-i18next';
import { getLang, getToFixed } from '../../../helpers/utils';
import { InfoAreaIcon } from '../../../assets/icons';
import { useUser } from '../../../contexts/user.context';

const SnpInfo = () => {
    const { t } = useTranslation();
    const { generalInfo, childInfoList } = useKato().katoGeneralInfo;
    const { getCurrentKato } = useKato();
    const { isModulePresent } = useUser();

    console.log(snpInfoData)

    if (!generalInfo) return null;

    if (!isModulePresent('snp-info')) return null;


    return (
        <div className={classes['snp-info']}>
            {
                snpInfoData.map((item) => (isModulePresent(item.title) &&
                    <div key={item.title} className={classes['snp-info__block']}>
                        <div className={classes['snp-info__block__header']}>
                            <div className={classes['snp-info__icon']}>{item.icon}</div>
                            <span className={classes['snp-info__block__title']}>{t(item.title)}</span>
                            <span className={classes['snp-info__block__suffix']}>{t(item.suffix)}</span>
                        </div>
                        <div className={classes['snp-info__items']}>
                            {item.items.map((subItem) => ( subItem && (subItem?.parentTitle && (generalInfo as any)?.[subItem.parentTitle]?.[subItem.valueKey] || (generalInfo as any)?.[subItem.valueKey]) && 
                                <div key={subItem.title} className={`${classes['snp-info__item']} ${subItem.title === 'total' ? classes['snp-info__item--total'] : ''}`}>
                                    <div
                                        className={classes['snp-info__percentage']}
                                        style={{ ['--angle' as any]: `${((subItem.percentage ?? 0) / 100) * 360}deg` }}

                                    >
                                        <span>{getToFixed(subItem.percentage ?? 0, 2)}%</span>
                                    </div>
                                    <span className={classes['snp-info__value']}>
                                        <span className={classes['snp-info__value-title']}>{t(subItem.title)}</span>
                                        <span>{((subItem?.parentTitle
                                            ? (generalInfo as any)?.[subItem.parentTitle]?.[subItem.valueKey]
                                            : (generalInfo as any)?.[subItem.valueKey]) ?? 0).toLocaleString('ru')}</span>
                                    </span>

                                </div>
                            ))}
                        </div>
                    </div>
                ))
            }

            {isModulePresent('area') && <div className={classes['snp-info__block']}>
                <div className={classes['snp-info__block__header']}>
                    <div className={classes['snp-info__icon']}>{<InfoAreaIcon />}</div>
                    <span className={classes['snp-info__block__title']}>{t('area')}</span>
                    <span className={classes['snp-info__block__suffix']}>{t('km2')}</span>
                </div>
                <div className={classes['snp-info__children']}>
                    <div className={classes['snp-info__column']}>
                        {
                            [
                                ...(getCurrentKato ? [{ ...getCurrentKato(), area: generalInfo.area ?? 0 }] : []),
                                ...childInfoList]
                                .splice(0, childInfoList.length / 2 + 1).map((item) => (
                                    <div key={item.kato + '' + Math.random()} className={classes['snp-info__child']}>
                                        <span className={classes['snp-info__child-title']}>{item[`name${getLang()}`]}</span>
                                        <span className={classes['snp-info__child-area']}>{(item.area ?? 0).toLocaleString('ru')}</span>
                                    </div>
                                ))
                        }
                    </div>

                    <div className={classes['snp-info__column']}>
                        {
                            [
                                ...childInfoList].splice(childInfoList.length / 2 + 1, childInfoList.length).map((item) => (
                                    <div key={item.kato + '' + Math.random()} className={classes['snp-info__child']}>
                                        <span className={classes['snp-info__child-title']}>{item[`name${getLang()}`]}</span>
                                        <span className={classes['snp-info__child-area']}>{(item.area ?? 0).toLocaleString('ru')}</span>
                                    </div>
                                ))
                        }

                    </div>
                </div>
            </div>}
        </div>
    )
}

export default SnpInfo